import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roles-settings',
  templateUrl: './roles-settings.component.html',
  styleUrls: ['./roles-settings.component.scss']
})
export class RolesSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
